export default __webpack_public_path__ + "static/media/table-details-arrow.eacd6139.svg";